(() => {
  const INTERVAL_DEFAULT = 4000;

  function initAnnouncementSection(root) {
    // Find the slider inside this section
    const slider = root.querySelector('[data-js-slider]');
    if (!slider) return;

    const items = Array.from(slider.querySelectorAll('.announcement'));
    if (items.length <= 1) return;

    // Prevent double init (Theme Editor re-renders sections)
    if (slider.dataset.announceInit === '1') return;
    slider.dataset.announceInit = '1';

    const prevBtn = root.querySelector('.announcement-bar__content-nav--left');
    const nextBtn = root.querySelector('.announcement-bar__content-nav--right');

    // Create a simple "active index"
    let index = 0;
    let timer = null;
    let paused = false;

    // Make sure only one announcement shows at a time
    function render() {
      items.forEach((el, i) => {
        el.style.display = i === index ? 'inline' : 'none';
      });

      // If you want to keep the left disabled style on first item only, uncomment next lines
      // if (prevBtn) {
      //   prevBtn.classList.toggle('announcement-bar__content-nav--disabled', index === 0);
      // }
    }

    function next() {
      index = (index + 1) % items.length;
      render();
    }

    function prev() {
      index = (index - 1 + items.length) % items.length;
      render();
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      const interval = INTERVAL_DEFAULT;
      timer = setInterval(() => {
        if (!paused) next();
      }, interval);
    }

    // Init display + autoplay
    render();
    start();

    // Pause on hover/focus so users can read
    root.addEventListener('mouseenter', () => (paused = true));
    root.addEventListener('mouseleave', () => (paused = false));
    root.addEventListener('focusin', () => (paused = true));
    root.addEventListener('focusout', () => (paused = false));

    // Buttons
    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        paused = true;
        next();
        setTimeout(() => (paused = false), 2000);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        paused = true;
        prev();
        setTimeout(() => (paused = false), 2000);
      });
    }
  }

  function initAll() {
    // Each section wrapper has a unique id: announcement-{{ section.id }}
    document.querySelectorAll('announcement-bar[id^="announcement-"]').forEach((sectionEl) => {
      initAnnouncementSection(sectionEl);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);

  // Theme editor hot reload for sections
  document.addEventListener('shopify:section:load', (e) => {
    if (!e || !e.target) return;
    e.target
      .querySelectorAll('announcement-bar[id^="announcement-"]')
      .forEach((sectionEl) => initAnnouncementSection(sectionEl));
  });
})();